import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Brand logo (CantiereAI helmet + wordmark + "© SynoraOs" attribution).
 *
 * Uses two PNG assets under /public:
 *  - cantiereai-logo.png       → dark text variant (for light backgrounds: navbar, hero light)
 *  - cantiereai-logo-light.png → white text variant (for dark backgrounds: footer, dark hero)
 *
 * The aspect ratio of the PNG is roughly 4:1 (helmet + wordmark).
 */
export const Logo = ({ className = '', variant = 'dark' }) => {
    const subColor = variant === 'dark' ? 'text-[hsl(220_13%_45%)]' : 'text-white/55';
    const src = variant === 'dark' ? '/cantiereai-logo.png' : '/cantiereai-logo-light.png';

    return (
        <Link
            to="/"
            className={`inline-flex flex-col items-start leading-none ${className}`}
            data-testid="logo-link"
            aria-label="CantiereAI"
        >
            <img
                src={src}
                alt="CantiereAI"
                width="160"
                height="40"
                className="h-8 sm:h-9 w-auto select-none"
                draggable="false"
                data-testid="logo-image"
            />
            <span
                className={`hidden sm:block text-[9px] mt-1 tracking-widest uppercase font-medium ${subColor}`}
                data-testid="logo-tagline"
            >
                © SynoraOs
            </span>
        </Link>
    );
};
